import type { TutorialCue } from "_shared/tutorials/tutorial-types";
import type { TutorialCuePreference } from "_shared/tutorials/_schemas/tutorial-preferences-schema";

export function getEligibleTutorialCues(args: {
  cues: readonly TutorialCue[];
  preferences: readonly TutorialCuePreference[];
  locallySuppressed: ReadonlySet<string>;
  targets: ReadonlyMap<string, HTMLElement>;
  pathname: string;
}): TutorialCue[] {
  const persisted = new Map(args.preferences.map((cue) => [`${cue.tutorialId}:${cue.cueId}`, cue]));
  return args.cues.filter((cue) => {
    const key = `${cue.tutorialId}:${cue.cueId}`;
    const preference = persisted.get(key);
    const target = args.targets.get(cue.targetId);
    const visible = Boolean(target && target.getClientRects().length && globalThis.getComputedStyle(target).display !== "none");
    return (
      visible &&
      !args.locallySuppressed.has(key) &&
      preference?.contentVersion !== cue.contentVersion &&
      (!cue.eligible || cue.eligible({ pathname: args.pathname, preferences: args.preferences }))
    );
  });
}
